module.exports = "<div ng-controller=\"TeamRecentAssignmentsCtrl as vm\"></div>";